/**
 * 公共方法
 */
exports.install = function (Vue,options){
        var _this=Vue.prototype;
        var CommonJs=Vue.prototype.$commonJs={};
        /**
         * 在新页面打开
         * @param {*} $this
         * @param {*} routeName
         * @param {*} param 参数对象，对象格式
         * */
       

        //部门列表
        CommonJs.getPart =function(level) {
                let param = {
                    level:level,
                }
                Vue.http.get('/jbbcs/organiza/loadDepartTree',{
                    responseType:'blob',      //告诉服务器我们需要的响应格式
                    params:param,
                    headers: {
                        "token":window.localStorage.getItem("token"),
                     },
                })
                .then(res => {
                    if(res.data.code==1){
                        return res.data  
                    }else if(res.data.code==0){
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    that.$message({ message: "执行失败，请重试", type: "error" });
                })
        }





}



// WEBPACK FOOTER //
// ./src/common/common.js